export default __webpack_public_path__ + "static/media/shopifyExtension4.a4ef186a.svg";